import * as angular from "angular";
import * as _ from "lodash";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { Utils } from "../../helper/utils.helper";

let CancelController = {
    selector: "cancel",
    templateUrl: "/angular/components/cancel/cancel.component.html",
    bindings: {},
    controller: class CancelController {
        private __env: any;
        private $scope: any;
        private $window: any;
        private toast: ToastUtils;
        private utils: Utils;
        private dialog: DialogUtils;

        public feedback: string = "";
        public deleteType: string | null = null;
        public noun: string = "subscription";
        public showFeedback: boolean | null = null;
        public dismissedPromo: boolean = false;
        public showEssentialsPromo: boolean = false;
        public showEssentialsOption: boolean = false;
        public essentialsAvailableCampaigns: Array<Campaign> = [];
        public loading: boolean = true;
        public country;
        public campaignid: number;
        public campaign: Campaign;
        public user;
        public selectedInterval: string;
        private onRouteChangeOff;
        private campaignDataProvider: CampaignDataProvider;

        constructor(
            $scope: any,
            $http: any,
            __env: any,
            $window: any,
            $routeParams: any,
            CampaignDataProvider: CampaignDataProvider,
            UserDataProvider: UserDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            Utils: Utils
        ) {
            this.__env = __env;
            this.$scope = $scope;
            this.$window = $window;
            this.toast = ToastUtils;
            this.utils = Utils;

            this.campaignid = $routeParams.campaignid;
            this.user = UserDataProvider.getActiveUser();
            this.campaignDataProvider = CampaignDataProvider;
            this.campaign = this.campaignDataProvider.getActiveCampaign();
            this.selectedInterval = this.campaign.cpinterval;
            this.dialog = DialogUtils;

            if (this.campaignid) {
                this.noun = "subscription";
            }

            this.$window.hj("trigger", "cancelPage"); // hotjar trigger

            this.onRouteChangeOff = this.$scope.$on(
                "$locationChangeStart",
                (event) => {
                    let answer = confirm(
                        `You haven't finished cancelling your ${this.noun}. Are you sure you want to leave this page?`
                    );
                    if (!answer) {
                        event.preventDefault();
                    } else {
                        window.onbeforeunload = undefined;
                    }
                }
            );

            window.onbeforeunload = (e) => {
                let message = `You haven't finished cancelling your ${this.noun}. Are you sure you want to leave this page?`;
                e = e || window.event;
                if (e) {
                    e.returnValue = true;
                }
                return message;
            };

            this.$scope.$on("$destroy", (e) => {
                this.onRouteChangeOff();
                window.onbeforeunload = undefined;
            });

            this.campaignDataProvider
                .ownerCampaigns(this.user.uid)
                .then((userOwnerCampaigns) => {
                    let campaigns = _.cloneDeep(userOwnerCampaigns);
                    angular.forEach(campaigns, (value) => {
                        if (value.essentialsModeAvailable(this.user.uid)) {
                            this.essentialsAvailableCampaigns.push(value);
                            if (
                                this.campaignid &&
                                this.campaignid == value.campaignid
                            ) {
                                this.showEssentialsOption = true;
                                this.showEssentialsPromo = true;
                            }
                        }
                    });
                    if (
                        !this.campaignid &&
                        this.essentialsAvailableCampaigns.length > 0
                    ) {
                        this.showEssentialsOption = true;
                        this.showEssentialsPromo = true;
                    }
                    this.loading = false;
                });

            $http.get("/api/campaign/plans").then((response) => {
                const json = response["data"];
                if (json.success) {
                    this.country = json.data[0].cpcountry;
                }
            });
        }

        $onInit() {
            this.$scope.$watch(
                () =>
                    `[ ${this.showEssentialsPromo}, ${this.deleteType}, ${this.dismissedPromo} ]`,
                (newValue, oldValue, scope) => {
                    setTimeout(() => {
                        document
                            .getElementById("changingPart")
                            .scrollIntoView({ behavior: "smooth" });
                    }, 20);
                }
            );

            this.$scope.$watch(
                () => this.showFeedback,
                (newValue, oldValue) => {
                    if (this.showFeedback) {
                        setTimeout(() => {
                            document
                                .getElementById("changingPart")
                                .scrollIntoView({ behavior: "smooth" });
                        }, 20);
                    }
                },
                true
            );
        }

        openIntercomChat() {
            this.$window.Intercom("showNewMessage");
        }

        selectOptions(option) {
            this.showFeedback = null;
            this.feedback = "";
            this.deleteType = option;
        }

        openEssentialsDialog(ev) {
            this.showFeedback = false;
            this.dialog
                .show({
                    component: "essentials-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedCampaign: this.campaignid,
                        currentUser: this.user,
                    },
                    ariaLabel: "Essentials Account",
                })
                .then((data: any) => {
                    this.loading = true;
                    this.campaignDataProvider
                        .setEssentialsModeForCampaigns(
                            data.selectedCampaigns,
                            data.restart_date,
                            this.selectedInterval
                        )
                        .then(
                            (json) => {
                                const campaignString =
                                    this.__env.strings.campaign[0].toUpperCase() +
                                    this.__env.strings.campaign.slice(1);
                                if (json.success) {
                                    if (json.data.length == 1) {
                                        this.toast.success(
                                            "Your subscription has been paused"
                                        );
                                    } else {
                                        this.toast.success(
                                            json.data.length +
                                                " subscriptions now paused"
                                        );
                                    }
                                    window.onbeforeunload = undefined;
                                    this.onRouteChangeOff();

                                    this.$window.history.back();
                                } else {
                                    this.toast.error();
                                }
                                this.loading = false;
                            },
                            () => {
                                this.loading = false;
                                this.toast.error(
                                    "Sorry, something went wrong. Please try again or contact support."
                                );
                            }
                        );
                });
        }

        openDeleteDialog(ev) {
            this.dialog
                .show({
                    component: "delete-account-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedCampaign: this.campaignid,
                        currentUser: this.user,
                    },
                    ariaLabel:
                        "Cancel {{'" +
                        this.__env.strings.campaign +
                        "' | capitalize}}s",
                })
                .then((selectedCampaigns) => {
                    this.loading = true;
                    this.campaignDataProvider
                        .cancelCampaigns(
                            selectedCampaigns,
                            this.feedback,
                            this.deleteType
                        )
                        .then(
                            (json) => {
                                window.onbeforeunload = undefined;
                                this.onRouteChangeOff();
                                if (
                                    !json.data.campaignid &&
                                    !json.data.length
                                ) {
                                    //if they are no longer on any campaign, log them out
                                    this.$window.location =
                                        "/goodbye.php?email=" +
                                        encodeURIComponent(this.user.uemail) +
                                        "&uid=" +
                                        this.user.uid;
                                } else {
                                    if (json.data.length == 1) {
                                        this.toast.success(
                                            this.__env.strings.campaign +
                                                " cancelled"
                                        );
                                    } else {
                                        this.toast.success(
                                            selectedCampaigns.length +
                                                " " +
                                                this.__env.strings.campaign +
                                                "s cancelled"
                                        );
                                    }
                                    if (json.activeCampaign) {
                                        this.utils.initNewCampaignData(
                                            json.activeCampaign
                                        );
                                    }

                                    this.$window.location = "/#/profile";
                                }
                                this.loading = false;
                            },
                            () => {
                                this.loading = false;
                                this.toast.error(
                                    "Sorry, something went wrong. Please try again or contact support."
                                );
                            }
                        );
                });
        }
    },
};

angular
    .module("cancel", [])
    .component(CancelController.selector, CancelController);
